import '@babel/polyfill'
import 'mutationobserver-shim'
import "./polyfill";
import Vue from "vue";
import './plugins/fontawesome'
import './plugins/bootstrap-vue'
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router/index";
import store from "./store";
import api from "./admin-api";
import underscore from "vue-underscore";
import moment from "moment";

moment.locale("nl");
Vue.use(moment);

Vue.prototype.moment = moment

Vue.filter('truncate', function (text, length, suffix) {
  if (text.length > length) {
      return text.substring(0, length) + suffix;
  } else {
      return text;
  }
});

Vue.filter("prettyBytes", function(num) {
  // jacked from: https://github.com/sindresorhus/pretty-bytes
  if (typeof num !== "number" || isNaN(num)) {
    throw new TypeError("Expected a number");
  }

  var exponent;
  var unit;
  var neg = num < 0;
  var units = ["B", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  if (neg) {
    num = -num;
  }

  if (num < 1) {
    return (neg ? "-" : "") + num + " B";
  }

  exponent = Math.min(
    Math.floor(Math.log(num) / Math.log(1000)),
    units.length - 1
  );
  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
  unit = units[exponent];

  return (neg ? "-" : "") + num + " " + unit;
});

Vue.filter("formatDateTime", function(value, formatting = "DD-MM-YYYY HH:mm") {
  if (value) {
    return moment(value).format(formatting);
  }
});

Vue.filter("fromNow", function(value) {
  if (value) {
    return moment(value).fromNow();
  }
});

Vue.filter("formatNumber", function(value, formatStyle = "decimal") {
  var options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    currency: "EUR",
    style: formatStyle
  };
  return Number(value).toLocaleString("nl-NL", options);
});

Vue.use(BootstrapVue);
Vue.use(underscore);

Vue.prototype.$http = api;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  components: {
    App
  },
  data: function() {
    return {};
  },
  router,
  beforeCreate() {
    this.$store.commit("initialiseStore");
    this.$store.dispatch('relaties/refreshIfStale');
  },
  mounted() {},
  template: "<App/>",
  store,
});
